import { env } from '@js/utils/env'

import axios from 'axios'
import gql from '@js/api/utils/gql'
import getBearerToken from '@js/api/utils/getBearerToken'
import getStoreName from '@js/api/utils/getStoreName'

const removeStoreCreditMutation = gql`
  mutation removeStoreCredit($input: RemoveStoreCreditFromCartInput!) {
    removeStoreCreditFromCart(input: $input) {
      cart {
        prices {
          grand_total {
            value
            currency
          }
          subtotal_excluding_tax {
            value
            currency
          }
          subtotal_including_tax {
            value
            currency
          }
          discounts {
            amount {
              value
            }
          }
        }
      }
    }
  }
`

export const removeStoreCredit = async (cartId: string) => {
  const token = getBearerToken()

  const { data } = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      Store: getStoreName()
    },
    data: {
      query: removeStoreCreditMutation,
      variables: {
        input: { cart_id: cartId }
      }
    }
  })

  return data.data?.removeStoreCreditFromCart?.cart || null
}
